// extracted by mini-css-extract-plugin
export default {"cnt_viewer":"GLIFOSPdfViewer_cnt_viewer__KHj4g"};